export var StyleEnum;
(function (StyleEnum) {
    //The default style - solid.
    StyleEnum[StyleEnum["none"] = 0] = "none";
    StyleEnum[StyleEnum["dashed"] = 1] = "dashed";
    StyleEnum[StyleEnum["solid"] = 2] = "solid";
    StyleEnum[StyleEnum["invis"] = 3] = "invis";
    StyleEnum[StyleEnum["bold"] = 4] = "bold";
    StyleEnum[StyleEnum["filled"] = 5] = "filled";
    StyleEnum[StyleEnum["diagonals"] = 6] = "diagonals";
    StyleEnum[StyleEnum["dotted"] = 7] = "dotted";
    StyleEnum[StyleEnum["rounded"] = 8] = "rounded";
})(StyleEnum || (StyleEnum = {}));
//# sourceMappingURL=styleEnum.js.map